module.exports = __webpack_public_path__ + "static/media/baf.fb73c970.png";